import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const COMPANY = {
  name: "Xpertee Pharma Services",
  legalName: "Xpertee Pharma Services Private Limited",
  shortName: "Xpertee",
  tagline: "Precision. Compliance. Global Excellence.",
  address: "NGJ-112, DLF New Town Heights, Sector 90, Gurgaon 122505, Haryana, India",
  phone: "+91 98719 91523",
  whatsapp: "+91 74284 11522",
  email: "Catalyst@xpertee.in",
  director: "Manoj Kumar",
  directorTitle: "Director",
  foundingYear: 2002,
};

// 8 service pillars extracted from Xpertee's official offering document
export const SERVICES = [
  {
    id: "procurement-support",
    title: "Procurement Support",
    short:
      "Strategic sourcing of APIs, raw materials and formulations through a transparent agency model.",
    description:
      "We streamline your global supply chain by strategically sourcing Active Pharmaceutical Ingredients, raw materials and finished formulations — using an agency model that keeps your procurement lean, traceable and audit-ready.",
    bullets: [
      "Active Pharmaceutical Ingredients (APIs)",
      "Raw materials & intermediates",
      "Formulations & finished dosages",
      "Agency-model supply chain",
    ],
    icon: "PackageSearch",
  },
  {
    id: "technical-sales-bd",
    title: "Technical Sales & Business Development",
    short:
      "We handle the technical complexities of your business relationships so you can focus on commercial success.",
    description:
      "From qualification questionnaires and quality agreements to sampling, complaint handling and site intelligence — we act as the technical backbone of your commercial pipeline.",
    bullets: [
      "Customer & vendor qualification governance",
      "Site Assessment & Quality Agreements",
      "Sampling, complaints & technical inquiry management",
      "Expert-led site audits & Gemba walks",
    ],
    icon: "Handshake",
  },
  {
    id: "strategic-service-support",
    title: "Strategic Service Support",
    short:
      "The technical backbone for your manufacturing and laboratory operations.",
    description:
      "Working standards, formulation & method troubleshooting, dissolution profiling, impurity control and method optimisation — delivered by experienced pharma scientists.",
    bullets: [
      "Qualified working standards (API supplied by user)",
      "Formulation & analytical method troubleshooting",
      "Dissolution profiling & bioavailability optimisation",
      "Impurity identification, qualification & control",
    ],
    icon: "Beaker",
  },
  {
    id: "advanced-characterization",
    title: "Advanced Characterization",
    short:
      "State-of-the-art analytical characterization for APIs, excipients and finished products.",
    description:
      "Particle size analysis (Malvern Mastersizer), solid-state characterization (PXRD, DSC, TGA), routine chromatography (HPLC, GC, UV) and specialised mass spectrometry (LCMS, GCMS, ICPMS).",
    bullets: [
      "Particle size — Malvern Mastersizer",
      "Solid state — PXRD, DSC, TGA",
      "Chromatography — HPLC, GC, UV advisory",
      "Mass spec — LCMS, GCMS, ICPMS",
    ],
    icon: "Atom",
  },
  {
    id: "microbiological-testing",
    title: "Microbiological Testing",
    short:
      "Sterility, bioburden and endotoxin testing to safeguard product quality.",
    description:
      "Comprehensive microbiological testing services — including sterility confirmation, pre-sterilization bioburden quantification, and bacterial endotoxin (LPS) detection for sterile injectables.",
    bullets: [
      "Sterility testing (viable microorganism absence)",
      "Bioburden — total microbial count pre-sterilization",
      "Endotoxin (LPS) detection for injectables",
      "Compendial protocols (USP / EP / IP)",
    ],
    icon: "Bug",
  },
  {
    id: "stability-studies",
    title: "Comprehensive Stability Studies",
    short:
      "Real-time and accelerated stability testing for APIs and formulations.",
    description:
      "Full ICH-aligned stability studies conducted in state-of-the-art chambers, with analytical work carried out at affiliated testing labs — enabling accurate shelf-life determination and regulatory filings.",
    bullets: [
      "Real-time & accelerated stability testing",
      "State-of-the-art ICH-compliant chambers",
      "API + formulation sample analysis",
      "Regulatory-ready stability data packages",
    ],
    icon: "Thermometer",
  },
  {
    id: "regulatory-facility",
    title: "Regulatory & Facility Excellence",
    short:
      "Navigate global regulatory markets with partners who understand the fine print.",
    description:
      "End-to-end dossier management for regulated and semi-regulated markets, SOP architecture, audit readiness consultancy and QC lab coaching to maintain a permanent state of inspection readiness.",
    bullets: [
      "Global dossier management — US FDA, EU, Japan, Korea, Middle East",
      "SOP architecture for on-site manufacturing",
      "USFDA, EU-GMP, MHRA audit-readiness consultancy",
      "QC lab specialist coaching",
    ],
    icon: "ShieldCheck",
  },
  {
    id: "qms-training",
    title: "Quality Systems & Expert Training",
    short:
      "Building a culture of quality through rigorous investigation and professional development.",
    description:
      "Specialist QMS investigation support for critical events and industry-leading training modules that build inspection-ready capability across your workforce.",
    bullets: [
      "Incidents, deviations, CAPA & change control",
      "OOS / OOC investigation expertise",
      "Data integrity training — modern expectations",
      "Core GMP & audit-strategy workshops",
    ],
    icon: "GraduationCap",
  },
];
